import { Route, Routes } from "react-router-dom";
import Prices from "../Pages/Price/Prices";
import Blog from "../Pages/Blog/Blog";
import Contact from "../Pages/Contact";
import Home from "../Pages/Home/Home";
import About from "../Pages/About/About";
import KYCForm from "../Pages/KYC/KYCForm";
import Help from "../Pages/Help";
import Security from "../Pages/Security";
import Compliance from "../Pages/Compliance";
import Terms from "../Pages/Terms";
import Privacy from "../Pages/Privacy";
import Disclosures from "../Pages/Disclosures";
import Cookies from "../Pages/Cookies";

const RoutePath = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/prices" element={<Prices />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/kyc" element={<KYCForm />} />
        <Route path="/help" element={<Help />} />
        <Route path="/security" element={<Security />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/disclosures" element={<Disclosures />} />
        <Route path="/cookies" element={<Cookies />} />
      </Routes>
    </>
  );
};

export default RoutePath;
